export function USFlag(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="United States" clipPath="url(#clip0_377_4883)">
        <path
          id="Vector"
          d="M8 15.999C12.4183 15.999 16 12.4173 16 7.99902C16 3.58075 12.4183 -0.000976562 8 -0.000976562C3.58172 -0.000976562 0 3.58075 0 7.99902C0 12.4173 3.58172 15.999 8 15.999Z"
          fill="#F0F0F0"
        />
        <g id="Group">
          <path
            id="Vector_2"
            d="M7.65219 7.99908H16C16 7.27702 15.9038 6.57752 15.7244 5.91211H7.65219V7.99908Z"
            fill="#D80027"
          />
          <path
            id="Vector_3"
            d="M7.65219 3.82525H14.8258C14.3361 3.02612 13.7099 2.31978 12.9799 1.73828H7.65219V3.82525Z"
            fill="#D80027"
          />
          <path
            id="Vector_4"
            d="M8.00002 15.9994C9.8828 15.9994 11.6133 15.3486 12.9799 14.2603H3.02014C4.3867 15.3486 6.11724 15.9994 8.00002 15.9994Z"
            fill="#D80027"
          />
          <path
            id="Vector_5"
            d="M1.1742 12.1729H14.8258C15.219 11.5314 15.5239 10.8301 15.7244 10.0859H0.275604C0.476135 10.8301 0.781042 11.5314 1.1742 12.1729Z"
            fill="#D80027"
          />
        </g>
        <path
          id="Vector_6"
          d="M3.70575 1.24834H4.43478L3.75666 1.74099L4.01569 2.53815L3.33759 2.04549L2.6595 2.53815L2.88325 1.84949C2.28619 2.34684 1.76287 2.92952 1.33162 3.57877H1.56522L1.13356 3.89237C1.06631 4.00455 1.00181 4.11852 0.94 4.23418L1.14612 4.86859L0.761563 4.58918C0.665969 4.79171 0.578531 4.9988 0.499938 5.21021L0.727031 5.90921H1.56522L0.887094 6.40187L1.14612 7.19902L0.468031 6.70637L0.0618437 7.00149C0.0211875 7.3283 0 7.66118 0 7.99902H8C8 3.58077 8 3.0599 8 -0.000976562C6.41963 -0.000976562 4.94641 0.457461 3.70575 1.24834ZM4.01569 7.19902L3.33759 6.70637L2.6595 7.19902L2.91853 6.40187L2.24041 5.90921H3.07859L3.33759 5.11205L3.59659 5.90921H4.43478L3.75666 6.40187L4.01569 7.19902ZM3.75666 4.07143L4.01569 4.86859L3.33759 4.37593L2.6595 4.86859L2.91853 4.07143L2.24041 3.57877H3.07859L3.33759 2.78162L3.59659 3.57877H4.43478L3.75666 4.07143ZM6.88525 7.19902L6.20716 6.70637L5.52906 7.19902L5.78809 6.40187L5.10997 5.90921H5.94816L6.20716 5.11205L6.46616 5.90921H7.30434L6.62622 6.40187L6.88525 7.19902ZM6.62622 4.07143L6.88525 4.86859L6.20716 4.37593L5.52906 4.86859L5.78809 4.07143L5.10997 3.57877H5.94816L6.20716 2.78162L6.46616 3.57877H7.30434L6.62622 4.07143ZM6.62622 1.74099L6.88525 2.53815L6.20716 2.04549L5.52906 2.53815L5.78809 1.74099L5.10997 1.24834H5.94816L6.20716 0.45118L6.46616 1.24834H7.30434L6.62622 1.74099Z"
          fill="#0052B4"
        />
      </g>
      <defs>
        <clipPath id="clip0_377_4883">
          <rect width="16" height="16" fill="white" transform="translate(0 -0.000976562)" />
        </clipPath>
      </defs>
    </svg>
  );
}
